import React from 'react';
import { ColumnItem } from '../../components/column-item';
import { toSafeColor } from '../../utils/to-safe-color';
export const ItemPrice = ({ section, item }) => {
    var _a;
    if (((_a = section.show) === null || _a === void 0 ? void 0 : _a.price) === false) {
        return null;
    }
    return (React.createElement(ColumnItem, { align: section.price.align, padding: "0px" },
        React.createElement("div", { style: {
                fontFamily: section.price.fontFamily,
                fontSize: section.price.fontSize,
                fontStyle: section.price.fontStyle,
                fontWeight: section.price.fontWeight || undefined,
                lineHeight: section.price.lineHeight,
                textAlign: section.price.align,
                textDecoration: section.price.textDecoration,
                color: toSafeColor(section.price.color),
                whiteSpace: 'pre-wrap',
            } },
            item.discountedPrice,
            item.discountedPrice !== item.price && (React.createElement(React.Fragment, null,
                "\u00A0",
                React.createElement("span", { style: { textDecoration: 'line-through' } }, item.price))))));
};
//# sourceMappingURL=item-price.js.map